import type { HighlighterApi } from '@highlight-cp/highlighter-api';

export interface ProfileSurvey extends HighlighterApi.HighlighterSurveyRead {
  isCore: boolean;
}

export enum ProfileSurveyStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  NOT_STARTED = 'NOT_STARTED',
  DISABLED = 'DISABLED',
}

export type ProfileTileIconMap<K extends ProfileSurveyStatus> = {
  [P in K]?: React.ReactNode;
};
